<template>
	<Transition name="fade">
		<div v-show="show && !loading">
      <FootballStatsDirectMatches
          v-if="!loading"
          :common-league-id="+sharedLeague.league_id"
          :matches="directMatches.slice()"
          :team-a="teamADetails"
          :team-b="teamBDetails"
          show-only-next-match
      />
      <div class="border-t border-x border-zt-light rounded-t-zt py-2.5 flex items-center justify-center bg-[#242E3D]">
        <div :class="view === 'a' ? 'bg-zt-light' : 'zt-hover text-zt-more cursor-pointer'"
             @click="view = 'a'; countClicks('Widok A w PORÓWNANIU', 'football')"
            class="py-[7.5px] px-[30px] text-xs transition-colors font-medium uppercase border border-zt-light rounded-l-zt">
          Widok A
        </div>
        <div :class="view === 'b' ? 'bg-zt-light' : 'zt-hover text-zt-more cursor-pointer'"
             @click="view = 'b'; countClicks('Widok B w PORÓWNANIU', 'football')"
            class="py-[7.5px] px-[30px] text-xs transition-colors font-medium uppercase border border-zt-light border-l-0 rounded-r-zt">
          Widok B
        </div>
      </div>
			<div class="grid grid-cols-12 text-sm font-semibold justify-between p-3 border-x border-t border-zt-light
			             bg-zt-light/35" >
				<div class="flex flex-col text-center gap-y-2 items-center gap-x-2 col-span-5 xl:flex-row xl:text-left">
					<div class="w-[59px] h-[44px] p-[6px] flex items-center justify-center border bg-[#eee] border-zt-light-bg
	                  rounded-zt xl:w-[72px] xl:h-[56px]">
						<img @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
								 :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamADetails.query_name}.png`"
		             :alt="teamADetails.name" class="h-full object-contain mx-auto" />
					</div>
					<a :href="`/wyniki-pilka-nozna/druzyny/${teamADetails.query_name}/`"
	           class="no-default-style zt-hover cursor-pointer grid place-items-center">
	          {{ teamADetails.short_name ? teamADetails.short_name : teamADetails.name }}
	        </a>
				</div>
				<div class="col-span-2 flex items-center flex-col justify-center">
					<a :href="`/wyniki-pilka-nozna/porownanie-druzyn/${teamBDetails.query_name}/${teamADetails.query_name}/`" class="no-default-style">
						<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
						  <g clip-path="url(#clip0_32412_70248)">
						    <path d="M6.29297 4.39712C6.29297 5.13189 6.29668 5.43618 6.30039 5.07622C6.30781 4.71626 6.30781 4.11509 6.30039 3.74029C6.29668 3.36548 6.29297 3.66236 6.29297 4.39712Z" fill="#96ECEC"/>
						    <path d="M1.91806 7.34023C1.90693 7.35879 2.8792 8.3459 4.07783 9.54082L6.25615 11.708L4.09267 9.53711C2.90517 8.34219 1.94033 7.35137 1.95517 7.33652C1.97002 7.32168 1.97373 7.31055 1.95888 7.31055C1.94775 7.31055 1.9292 7.32539 1.91806 7.34023Z" fill="#96ECEC"/>
						    <path d="M12.7109 8.6647C12.7109 9.39947 12.7146 9.70376 12.7184 9.3438C12.7258 8.98384 12.7258 8.38267 12.7184 8.00786C12.7146 7.63306 12.7109 7.92993 12.7109 8.6647Z" fill="#96ECEC"/>
						    <path d="M14.4373 8.99902C14.5078 9.06953 14.5709 9.12891 14.5821 9.12891C14.5932 9.12891 14.545 9.06953 14.4744 8.99902C14.4039 8.92852 14.3409 8.86914 14.3297 8.86914C14.3186 8.86914 14.3668 8.92852 14.4373 8.99902Z" fill="#96ECEC"/>
						    <path d="M6.29297 10.3346C6.29297 11.0694 6.29668 11.3737 6.30039 11.0137C6.30781 10.6538 6.30781 10.0526 6.30039 9.67779C6.29668 9.30298 6.29297 9.59986 6.29297 10.3346Z" fill="#96ECEC"/>
						    <path d="M15.8393 10.398L17.0713 11.6338L14.8893 13.8232L12.7109 16.0127L14.9078 13.8232L17.1084 11.6338L15.8764 10.4018C15.1973 9.72266 14.6332 9.16602 14.6221 9.16602C14.6109 9.16602 15.1602 9.72266 15.8393 10.398Z" fill="#96ECEC"/>
						    <path d="M12.7109 14.6022C12.7109 15.337 12.7146 15.6413 12.7184 15.2813C12.7258 14.9213 12.7258 14.3202 12.7184 13.9454C12.7146 13.5706 12.7109 13.8674 12.7109 14.6022Z" fill="#96ECEC"/>
						    <path d="M4.08945 5.20273L1.92969 7.36621L4.10059 9.53711L6.27148 11.708V10.3424V8.98047H8.86914H11.4668V7.36621V5.75195H8.86914H6.27148L6.26406 4.39746L6.25293 3.04297L4.08945 5.20273Z" fill="#ECECEC"/>
						    <path d="M12.7266 8.65762V10.0195H10.1289H7.53125V11.6338V13.248H10.1289H12.7266L12.734 14.6025L12.7451 15.957L14.9086 13.7973L17.0684 11.6338L14.8975 9.46289L12.7266 7.29199V8.65762Z" fill="#ECECEC"/>
						  </g>
						  <defs>
						    <clipPath id="clip0_32412_70248">
						      <path d="M0 5C0 2.23858 2.23858 0 5 0H14C16.7614 0 19 2.23858 19 5V14C19 16.7614 16.7614 19 14 19H5C2.23858 19 0 16.7614 0 14V5Z" fill="white"/>
						    </clipPath>
						  </defs>
						</svg>
					</a>
					<a :href="`/wyniki-pilka-nozna/porownanie-druzyn/${teamBDetails.query_name}/${teamADetails.query_name}/`"
					   class="no-default-style underline cursor-pointer leading-5 zt-hover uppercase text-xs font-normal text-zt-more">
            Odwróć
          </a>
				</div>
				<div class="flex flex-col-reverse text-center gap-y-2 justify-end items-center gap-x-2 col-span-5
				            xl:flex-row xl:text-right">
					<a :href="`/wyniki-pilka-nozna/druzyny/${teamBDetails.query_name}/`"
	           class="no-default-style zt-hover cursor-pointer grid place-items-center">
	          {{ teamBDetails.short_name ? teamBDetails.short_name : teamBDetails.name }}
	        </a>
					<div class="w-[59px] h-[44px] p-[6px] flex items-center justify-center border bg-[#eee] border-zt-light-bg
	                  rounded-zt xl:w-[72px] xl:h-[56px]">
						<img @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
						     :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamBDetails.query_name}.png`"
	               :alt="teamBDetails.name" class="h-full object-contain mx-auto" />
					</div>
				</div>
			</div>
			<div class="pb-2 mb-4 xl:mb-2">
				<FootballStatsCompareResults :view="view" @loaded="loaded" :team-a-details="teamADetails" :team-a-id="teamAId"
	                                   :team-b-details="teamBDetails" :team-b-id="teamBId" />
			</div>

			<FootballStatsDirectMatches v-if="!loading" :matches="directMatches" :team-a="teamADetails" :team-b="teamBDetails"
                                  class="pb-4" :class="{ '!pb-0' : !showScorers }"/>

      <Transition name="fade" mode="out-in">
        <div class="mb-4 rounded-b-zt">
          <div class="uppercase bg-zt-light-full !h-[38px] px-[14px] flex items-center border cursor-pointer zt-hover
           border-zt-light rounded-t-zt text-xs"  @click="showUpcomingMatches = !showUpcomingMatches"
             :class="{'!rounded-b' : !showUpcomingMatches, '!border-b-transparent' : showUpcomingMatches}">
            Nadchodzące Mecze Ligowe
            <div class="h-full w-5 ml-auto flex items-center">
              <svg class="mx-auto transition" :class="{'rotate-180': !showUpcomingMatches}"
                  xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
                <path d="M7.50125 5.25L4.25 2.00583L0.99875 5.25L8.73132e-08 4.25125L4.25 0.00125371L8.5 4.25125L7.50125 5.25Z" fill="white"/>
              </svg>
            </div>
          </div>
          <Transition name="fade" mode="out-in">
            <div v-if="showUpcomingMatches" class="border-zt-light overflow-x-hidden border-t">
            <div v-if="teamAUpcomingMatches.length !== 0 || teamBUpcomingMatches.length !== 0" class="grid grid-cols-2">
              <div class="flex flex-col">
                <div class="bg-zt-light-full border-b border-x border-zt-light py-2.5 pl-2 text-xs uppercase flex flex-nowrap
					            items-center !h-[41px] max-h-[41px]" :class="[loading ? 'h-fit' : 'h-full']">
                  <img class="w-5 h-5 aspect-square object-contain mr-2"
                       @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                       :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamADetails.query_name}.png`"
                       :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"/>
                  <span class="truncate pr-1">{{teamADetails.shortname ? teamADetails.shortname : teamADetails.name }}</span>
                  <span class="ml-auto mr-4">1x2</span>
                </div>
                <Transition name="fade" mode="out-in">
                  <div v-if="loading" class="rounded-zt border border-zt-light mb-4 overflow-hidden">
                    <div class="bg-zt-light-full w-full h-[45px] flex items-center p-2">
                      <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
                    </div>
                    <div v-for="i in 3" class="border-b border-zt-light bg-zt-light/35 w-full h-[45px] flex items-center p-2">
                      <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="flex flex-col items-start w-full">
                      <div v-for="(match, index) of teamAUpcomingMatches" :key="match.match_id" class="w-full">
                        <FootballStatsListItem class="border-t-0" :class="{
									'border-r' : teamAUpcomingMatches.length < teamBUpcomingMatches.length && index + 1 > teamBUpcomingMatches.length,
									'rounded-br-none rounded-bl-zt' : index === teamAUpcomingMatches - 1,
          		    'rounded-bl-zt' : (teamAUpcomingMatches.length < teamBUpcomingMatches.length && index === teamAUpcomingMatches.length - 1) || index === 2}"
                                               :displaying-stat="'goals'"
                                               variant="compact"
                                               :show-odds="true"
                                               :show-hour="index === 0"
                                               :team-id="teamAId"
                                               :redirect-to-h2h="match.is_h2h_available"
                                               :show-relative-date="false"
                                               :ish2h="true"
                                               :show-scores="false"
                                               :match="match" show-date show-animation :show-double-match="false"/>
                      </div>
                    </div>
                    <p class="h-[50px] text-xs grid place-items-center bg-zt-light/35 text-zt-more border-x border-b border-zt-light rounded-b-zt"
                       v-if="teamAUpcomingMatches === 0 && teamBUpcomingMatches === 0 && (mobileView === 'a' && window.size.mobile)">
                      Brak meczów do wyświetlania
                    </p>
                  </div>
                </Transition>
              </div>
              <div class="flex flex-col">
                <div class="bg-zt-light-full border-b border-r border-zt-light py-2.5 pl-2 text-xs uppercase flex flex-nowrap
                      items-center !h-[41px] max-h-[41px]" :class="[loading ? 'h-fit' : 'h-full']">
                  <img class="w-5 h-5 object-contain aspect-square mr-2" :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamBDetails.query_name}.png`"
                       @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                       :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"/>
                  <span class="truncate pr-1">{{teamBDetails.shortname ? teamBDetails.shortname : teamBDetails.name }}</span>
                  <span class="ml-auto mr-4">1x2</span>
                </div>
                <Transition name="fade" mode="out-in">
                  <div v-if="loading" class="rounded-zt border border-zt-light mb-4 overflow-hidden">
                    <div class="bg-zt-light-full w-full h-[45px] flex items-center p-2">
                      <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
                    </div>
                    <div v-for="i in 5" class="border-b border-zt-light bg-zt-light/35 w-full h-[45px] flex items-center p-2">
                      <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="flex flex-col items-start w-full">
                      <div v-for="(match, index) of teamBUpcomingMatches" :key="match.match_id" class="w-full">
                        <FootballStatsListItem class="border-t-0 border-l-0 pl-px" :class="{
									'!border-l -ml-px !w-[calc(100%+1px)]' : teamBUpcomingMatches.length > teamAUpcomingMatches.length && index + 1 > teamAUpcomingMatches.length,
									'rounded-br-zt' : (teamBUpcomingMatches.length < teamAUpcomingMatches.length && index === teamBUpcomingMatches.length - 1) || index === 2,
									'rounded-none' : index === teamBUpcomingMatches.length - 1 }"
                                               :displaying-stat="'goals'"
                                               :team-id="teamBId"
                                               variant="compact"
                                               :show-hour="index === 0"
                                               :show-odds="true"
                                               :show-relative-date="false"
                                               :show-scores="false"
                                               :ish2h="true"
                                               :redirect-to-h2h="match.is_h2h_available"
                                               :match="match" show-date show-animation :show-double-match="false"/>
                      </div>
                    </div>
                  </div>
                </Transition>
              </div>
            </div>
          </div>
          </Transition>
          <p class="h-[50px] text-xs grid place-items-center bg-zt-light/35 text-zt-more border-x border-b border-zt-light rounded-b-zt"
             v-if="teamAUpcomingMatches.length === 0 && teamBUpcomingMatches.length === 0 && showUpcomingMatches">
            Brak meczów do wyświetlania
          </p>
        </div>
      </Transition>


	    <Transition name="fade" mode="out-in">
				<div v-if="!loading && sharedLeague?.league_id">
					<div class="pb-6" v-if="teamADetails?.country !== 'World' && teamBDetails?.country !== 'World'">

						<FootballTable :season="sharedLeague.season"
						               :seasons-type="seasonsType"
                           :rounded-top="true"
                           :phases-rounded-top="false"
                           :redirect-to="`/wyniki-pilka-nozna/${teamADetails.country_query_name}/${sharedLeague.league_query_name}/tabela/`"
                           :selected-teams-ids="[teamAId, teamBId]"
                           :league-id="Number(sharedLeague?.league_id)">
              <template #title>
                <p class="no-default-style !text-xl !font-semibold w-fit flex gap-x-[7px] items-center pl-2.5 xl:pl-0">
                  <span>Tabela - {{ sharedLeague.league_name }}</span>
                </p>
              </template>
            </FootballTable>
					</div>
					<div class="pb-6" v-if="teamADetails?.country !== 'World' && teamBDetails?.country !== 'World' && sharedLeague?.league_id !== '342'">
						<FootballStatsCompareH2H :league-id="Number(sharedLeague?.league_id)"
                                     :team-a-query-name="teamADetails.query_name"
                                     :team-b-query-name="teamBDetails.query_name"
                                     :team-b-id="teamBId"
                                     :season="sharedLeague.season"
                                     :seasons-type="seasonsType"
                                     :team-a-id="teamAId"/>
					</div>
					<div v-if="showScorers">
						<p class="text-xl font-semibold pl-2.5 pb-3 xl:pl-0"
						   :class="{ 'mt-[15px]' : teamADetails?.country === 'World' && teamBDetails?.country === 'World' }">
							Strzelcy obu drużyn {{ [4,9].includes(Number(sharedLeague?.league_id)) ? '('+sharedLeague.league_name+')' : ''}}
						</p>
            <div v-if="window.size.desktop && multiplePhasesPresent" class="px-2 py-2.5 border-x grid grid-cols-2 gap-x-[44px] border-t rounded-t-zt border-zt-light bg-zt-light-opacity">
              <div class="basis-1/2 w-full text-xs py-[5px] text-center rounded-zt border border-zt-light flex items-center justify-center">
                <span class="opacity-30">{{ sharedLeague.season }}{{ seasonsType === 'season' ? `/${+sharedLeague.season + 1}` : ''}}</span>
              </div>
              <div>
                <PickFilterModal
                    customClasses="bg-zt-light-opacity flex pl-4 items-center
                             border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                    custom-header-classes="text-center !text-xs w-full !font-normal"
                    :options="phaseOptions"
                    :defaultOption="selectedPhaseOption.name"
                    :selectedOption="selectedPhaseOption.name"
                    :showIcons="false"
                    :type="'full'"
                    slide-bottom-modal
                    @optionSelected="(option) => selectedPhaseOption = phaseOptions.find(el => el.name === option)"
                />
              </div>
            </div>
            <div
                :class="{ 'grid-cols-2' : multiplePhasesPresent, 'rounded-t-zt' : !multiplePhasesPresent || (multiplePhasesPresent && window.size.mobile) }"
                class="px-2.5 py-3 grid bg-zt-light-opacity gap-x-[7px] border border-zt-light border-b-0 xl:grid-cols-1">
              <PickFilterModal
                  customClasses="bg-zt-light-opacity flex pl-4 items-center
                             border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                  custom-header-classes="text-center !text-xs w-full !font-normal"
                  :options="options"
                  :defaultOption="selected_phase.name"
                  :selectedOption="selected_phase.name"
                  :showIcons="false"
                  :type="'full'"
                  slide-bottom-modal
                  @optionSelected="(option) => selected_phase = options.find(el => el.name === option)"
              />
              <PickFilterModal
                  v-if="window.size.mobile && multiplePhasesPresent"
                  customClasses="bg-zt-light-opacity flex pl-4 items-center
                             border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                  custom-header-classes="text-center !text-xs w-full !font-normal"
                  :options="phaseOptions"
                  :defaultOption="selectedPhaseOption.name"
                  :selectedOption="selectedPhaseOption.name"
                  :showIcons="false"
                  :type="'full'"
                  slide-bottom-modal
                  @optionSelected="(option) => selectedPhaseOption = phaseOptions.find(el => el.name === option)"
              />
            </div>
          <FootballTabScorersTable
                   :players="selectedScorers"
                   :pageType="'compare'"
                   :show-only-goals="leaguesWithoutAssists"
                   :expand-no="10"
                   :show-no="5"
                   :league="sharedLeague"
                   :phase="selectedPhaseOption.value"
                   :table-type="selected_phase.value"/>
<!--            <OtherLeagueMatches :team-a-id="teamAId" :team-b-id="teamBId" :league-id="sharedLeague.league_id"/>-->
					</div>
				</div>
			</Transition>
		</div>
	</Transition>
</template>

<script>
import FootballTable from "./FootballTable.vue";
import FootballStatsScorers from "../components/blocks/FootballStatsScorers.vue";
import FootballTabScorersTable from "../components/blocks/FootballTabScorersTable.vue";
import FootballStatsCompareResults from "./FootballStatsCompareResults.vue";
import H2hTable from "../components/football_stats/tables/H2hTable.vue";
import FootballStatsCompareH2H from "./FootballStatsCompareH2H.vue";
import FootballStatsDirectMatches from "./FootballStatsDirectMatches.vue";
import PickFilterModal from "../components/modals/PickFilterModal.vue";
import utils_mixin from "../mixins/utils_mixin";
import OtherLeagueMatches from "./OtherLeagueMatches.vue";
import FootballStatsListItem from "../components/blocks/FootballStatsListItem.vue";

export default {
	name: 'FootballStatsCompareTeams',
	components: {
    FootballStatsListItem,
    OtherLeagueMatches,
    PickFilterModal,
		FootballStatsDirectMatches,
		FootballStatsCompareH2H,
		H2hTable,
		FootballStatsCompareResults,
		FootballTabScorersTable,
		FootballStatsScorers,
		FootballTable
	},
	inject: ['WP'],
  mixins: [utils_mixin],
	props: ['seasonsType'],
	data() {
		return {
			loading: true,
			teamADetails: {},
			teamBDetails: {},
			teamAScorers: [],
			teamBScorers: [],
      teamAUpcomingMatches: [],
			teamBUpcomingMatches: [],
			selectedScorers: {},
			directMatches: [],
      sharedLeague: [],
			show: false,
      selectOpen: false,
      selected_phase: {name:'Bramki / asysty', value: 'normal', active: true},
      options: [
        {name:'Bramki / asysty', value: 'normal', active: true},
        {name:'Punktacja kanadyjska', value: 'canadian', active: true},
        {name:'Udział zawodnika w bramkach drużyny (B+A)', value: 'percentage', active: true}
      ],
      view: 'a',
      selectedPhaseOption: {name:'Cały sezon', value: 'regular', active: true},
      showUpcomingMatches: false
		}
	},
	async mounted() {
		await this.loadTeamsInfo();
		await this.loadTeamsScorers();
		await this.getDirectMatches();
    await this.loadNextMatches();
		this.loading = false;
	},
	computed: {
    multiplePhasesPresent() {
      return this.selectedScorers.championship.length > 0 || this.selectedScorers.relegation.length > 0 || this.selectedScorers.conference.length > 0;
    },
    phaseOptions() {
      let options = [];
      const names = {
        'regular': 'Cały sezon',
        'championship': 'Grupa Mistrzowska',
        'relegation': 'Grupa Spadkowa',
        'conference': 'Grupa Ligi Konferencji'
      };
      Object.keys(names).forEach(key => {
        if (this.selectedScorers[key].length > 0) {
          options.push({name: names[key], value: key, active: true});
        }
      })
      return options;
    },
		showScorers() {
			return this.teamADetails.country !== 'World';
		},
		showAndLoaded() {
			return `${this.show}|${this.loading}`;
		},
		teamAId() {
			return +this.$attrs.teamAId;
		},
		teamBId() {
			return +this.$attrs.teamBId;
		},
    leaguesWithoutAssists() {
      if (Object.keys(this.teamADetails).length > 0 && Object.keys(this.teamBDetails).length) {
        return [108, 47, 318, 172, 107, 310, 342, 419, 315, 408, 373, 355, 371, 283, 329, 327, 362, 107].some(league_id => {
          return league_id === Number(this.teamADetails.league_id) || league_id === Number(this.teamBDetails.league_id);
        })
      }
    },
	},
	watch: {
		showAndLoaded(newVal) {
			let [show, loading] = newVal.split('|');
			show = JSON.parse(show);
			loading = JSON.parse(loading);
			if (show && !loading) {
				this.removePlaceholder(this.$attrs.section);
			}
		},
	},
	methods: {
		loaded() {
			this.show = true;
		},
		async getDirectMatches() {
			const response = await axios.post(this.WP.slowAjaxUrl, {
					endpoint: 'api_get_direct_matches',
					team_a_id: this.teamAId,
					team_b_id: this.teamBId
				})
			this.directMatches = response.data.data.filter(match => match.status !== 'CANC');
		},
		displayingName(teamDetails) {
			if (teamDetails.short_name === '') {
				return teamDetails.name;
			}
			return teamDetails.short_name;
		},
		async loadTeamsInfo() {
			const responseA = await axios.post(this.WP.ajaxUrl, {
				endpoint: 'api_get_team_details',
				team_id: this.teamAId
			})
			this.teamADetails = responseA.data.data;
			const responseB = await axios.post(this.WP.ajaxUrl, {
				endpoint: 'api_get_team_details',
				team_id: this.teamBId
			})
			this.teamBDetails = responseB.data.data;
		},
		async loadTeamsScorers() {
      let sharedLeagueDetails = this.findCommonLeagues(this.teamADetails.team_leagues,this.teamBDetails.team_leagues);
      this.sharedLeague = sharedLeagueDetails[0];
			const response = await axios.post(this.WP.ajaxUrl, {
				endpoint: 'api_get_match_scorers',
				league_api_id: +sharedLeagueDetails[0].league_id,
				season: +sharedLeagueDetails[0].season
			})
			this.selectedScorers.regular = response.data.data.regular.filter(player => ( player.team_id === this.teamADetails.team_id || player.team_id === this.teamBDetails.team_id ) );
      this.selectedScorers.championship = response.data.data.championship.filter(player => ( player.team_id === this.teamADetails.team_id || player.team_id === this.teamBDetails.team_id ) );
      this.selectedScorers.relegation = response.data.data.relegation.filter(player => ( player.team_id === this.teamADetails.team_id || player.team_id === this.teamBDetails.team_id ) );
      this.selectedScorers.conference = response.data.data.conference.filter(player => ( player.team_id === this.teamADetails.team_id || player.team_id === this.teamBDetails.team_id ) );

			this.selectedScorers.regular.forEach((player, index) => player.position = index + 1);
      this.selectedScorers.championship.forEach((player, index) => player.position = index + 1);
      this.selectedScorers.relegation.forEach((player, index) => player.position = index + 1);
      this.selectedScorers.conference.forEach((player, index) => player.position = index + 1);

		},
    findCommonLeagues(team1Leagues, team2Leagues) {
      const team1LeagueIds = team1Leagues.map(league => league.league_id);
      const commonLeagues = team2Leagues.filter(league => team1LeagueIds.includes(league.league_id));

      commonLeagues.sort((a, b) => {
        if (a.type.includes('Cup') && !b.type.includes('Cup')) {
          return 1;
        }
        if (!a.type.includes('Cup') && b.type.includes('Cup')) {
          return -1;
        }
        return parseInt(a.league_id) - parseInt(b.league_id);
      });
      return commonLeagues;
    },
    async loadNextMatches() {
      const resScheduleHome = axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_team_schedule',
        team_id: this.teamAId,
        limit: 3
      }).then(resp => {
        this.rounds = resp.data.data;
        Object.values(this.rounds).forEach(round => {
          this.teamAUpcomingMatches.push(...round.round_matches);
        })
      })
      const resScheduleAway = axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_team_schedule',
        team_id: this.teamBId,
        limit: 3
      }).then(resp => {
        this.rounds = resp.data.data;
        Object.values(this.rounds).forEach(round => {
          this.teamBUpcomingMatches.push(...round.round_matches);
        })
      })

      await Promise.all([resScheduleHome, resScheduleAway])
    }
	}
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;

}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>